import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Alert, Button, TextField, Typography } from "@mui/material";
import { requestSandboxRefund, refreshSandboxRefund } from "../api/sandbox-refund";
import { paymentError } from "../api/payments";

export default function SandboxRefund() {
  const token = useSelector((state) => state.user.token);
  const [orderId, setOrderId] = useState(""), [refund, setRefund] = useState(null), [busy, setBusy] = useState(false), [error, setError] = useState("");
  const operation = useRef(null), pending = useRef(false);
  async function run(refresh) {
    if (pending.current) return;
    pending.current = true; setBusy(true); setError("");
    try {
      operation.current ||= crypto.randomUUID();
      setRefund(refresh ? await refreshSandboxRefund(token, operation.current)
        : await requestSandboxRefund(token, orderId.trim(), operation.current));
    } catch (reason) { setError(reason.message.startsWith("sandbox-") ? "فقط سفارش تست یک یورویی پذیرفته می‌شود؛ شناسه و تنظیمات را بررسی کنید." : paymentError(reason)); }
    finally { pending.current = false; setBusy(false); }
  }
  return <section className="mt-6">
    <Typography variant="h6">آزمایش بازپرداخت تست</Typography>
    <Alert severity="info" className="my-3">دو درخواست هم‌زمان با یک شناسه عملیات، فقط برای بازپرداخت ۱ یوروی سفارش TEST ارسال می‌شوند. وضعیت submitted تأیید نهایی بازپرداخت نیست؛ ممکن است تأیید شبیه‌ساز در داشبورد درگاه لازم باشد.</Alert>
    <TextField fullWidth label="شناسه سفارش تست برای بازپرداخت" value={orderId} disabled={busy || Boolean(refund)} onChange={(event) => setOrderId(event.target.value)} inputProps={{ dir: "ltr" }} />
    <div className="flex gap-3 my-3"><Button variant="outlined" disabled={busy || !orderId || Boolean(refund)} onClick={() => run(false)}>درخواست بازپرداخت تست ۱ یورویی</Button>
      {operation.current && <Button disabled={busy} onClick={() => run(true)}>استعلام بازپرداخت تست</Button>}</div>
    {refund && <Button disabled={busy} onClick={() => run(false)}>تکرار امن همان شناسه بازپرداخت</Button>}
    {error && <Alert severity="error">{error}</Alert>}
    {refund && <Alert severity="info">عملیات: <span dir="ltr">{refund.id}</span> — وضعیت: {refund.status} {refund.http && `— پاسخ درخواست‌های هم‌زمان: ${refund.http}`}</Alert>}
  </section>;
}
